<template lang="">
  <div class="basic-sales-promotion">
    <template v-if="showPop">
      <div class="bsp-main">
        <div class="more-box">
          <template v-for="(item, index) in labelData">
            <div class="item" v-if="index < 2">
              <span class="tag">{{ item.discountLabelTag }}</span>
              <p class="detail">{{ item.discountLabel }}</p>
            </div>
          </template>
        </div>

        <a
          href="javascript:;"
          class="unfold-btn"
          :class="{ unfold: unfold }"
          v-if="labelData.length > 2"
          @click="unfold = !unfold"
          >{{ unfold ? "收起" : "更多" }}</a
        >
      </div>

      <div class="unfold-pop" v-if="unfold">
        <div class="inner">
          <template v-for="(item, index) in labelData">
            <div class="item" v-if="index < 2 && showPop">
              <span class="tag">{{ item.discountLabelTag }}</span>
              <p class="detail">{{ item.discountLabel }}</p>
            </div>
            <div class="item" v-else-if="index > 1">
              <span class="tag">{{ item.discountLabelTag }}</span>
              <p class="detail">{{ item.discountLabel }}</p>
            </div>
          </template>
        </div>
      </div>
    </template>

    <template v-if="!showPop">
      <div class="bsp-main">
        <div class="mini-box" v-if="!unfold">
          <div class="mini-inner">
            <template v-for="(item, index) in labelData">
              <div class="mini-item">
                <span class="tag">{{ item.discountLabelTag }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="more-box" v-else>
          <template v-for="(item, index) in labelData">
            <div class="item" v-if="index < 1">
              <span class="tag">{{ item.discountLabelTag }}</span>
              <p class="detail">{{ item.discountLabel }}</p>
            </div>
          </template>
        </div>

        <a
          href="javascript:;"
          class="unfold-btn"
          :class="{ unfold: unfold }"
          v-if="labelData.length > 2"
          @click="unfold = !unfold"
          >{{ unfold ? "收起" : "更多" }}</a
        >
      </div>

      <div class="more-box" v-if="unfold">
        <div class="inner">
          <template v-for="(item, index) in labelData">
            <div class="item" v-if="index > 1">
              <span class="tag">{{ item.discountLabelTag }}</span>
              <p class="detail">{{ item.discountLabel }}</p>
            </div>
          </template>
        </div>
      </div>
      <!-- more-box -->
    </template>
  </div>
</template>
<script>
export default {
  props: {
    showPop: {
      type: Boolean,
      default: false
    },

    labelData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      unfold: false
    };
  }
};
</script>
<style lang="less" scoped>
.basic-sales-promotion {
  position: relative;
  z-index: 10;
  min-height: 26px;
  margin-bottom: 18px;
  line-height: 26px;

  @media (max-width: 500px) {
    min-height: 24px;
    line-height: 24px;
  }

  .bsp-main {
    display: flex;
    align-items: flex-start;
  }

  .label {
    width: 80px;
  }

  .item {
    display: flex;
    align-items: center;
    min-width: 25em;
    margin: 10px 40px 0 0;
    color: #737373;

    @media (max-width: 500px) {
      min-width: 18em;
      margin-right: 20px;
    }

    &:first-of-type {
      margin-top: 0;
    }

    .detail {
      font-size: 13px;
      line-height: 1.3;
    }
  }

  .mini-box {
    flex: 1;
  }

  .mini-inner {
    display: flex;
    flex-wrap: wrap;
    margin: -10px 0 0 -10px;
  }

  .mini-item {
    display: flex;
    margin: 10px 0 0 10px;

    .tag {
      margin-right: 0;
    }
  }

  .tag {
    width: 100px;
    min-width: 100px;
    margin-right: 15px;
    border-radius: 5px;
    border: 1px solid #008077;
    color: #008077;
    line-height: 24px;
    text-align: center;

    @media (max-width: 500px) {
      line-height: 22px;
    }
  }

  .unfold-btn {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    color: #008077;
    cursor: pointer;
    white-space: nowrap;

    &::after {
      content: "";
      width: 0;
      height: 0;
      margin-left: 10px;
      border-width: 0 6px 7px;
      border-style: solid;
      border-color: transparent transparent #008077 transparent;
      transform: rotate(180deg);
    }

    &.unfold::after {
      transform: rotate(0);
    }
  }

  .unfold-pop {
    position: absolute;
    top: 36px;
    right: 0;
    left: -20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;

    @media (max-width: 500px) {
      top: 34px;
    }

    .inner {
      padding: 20px 20px 20px 20px;
    }

    &.not-padding {
      padding-left: 0;
    }
  }

  .more-box {
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }
}

.mini-box {
}
</style>



// WEBPACK FOOTER //
// src/components/SalesPromotion/index.vue